export const config = {
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {title: '序号', dataIndex: 'sort', width: 120, render: 'sortRender'},
    {title: '费用名称', dataIndex: 'name', width: 200, render: 'nameRender', ellipsis: true},
    {title: '适用产品', dataIndex: 'productName', width: 200, ellipsis: true},
    {title: '适用门店', dataIndex: 'orgName', width: 200, ellipsis: true},
    {title: '适用空间标签', dataIndex: 'spaceName', width: 200, ellipsis: true},
    {title: '空间规格参数', dataIndex: 'spaceArgName', width: 200, ellipsis: true},
    {title: '参数值', dataIndex: 'spaceArgValueName', width: 200, ellipsis: true},
    {title: '金额（元）', dataIndex: 'price', width: 200, ellipsis: true},
    {title: '开始日期', dataIndex: 'startDate', width: 180, itemType: 'date'},
    {title: '结束日期', dataIndex: 'endDate', width: 180, itemType: 'date'},
    {title: '操作', dataIndex: '#', width: 140, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {name: 'prodCateId', hidden: true},
    {
      label: '适用产品', name: 'productNameKey'
    },
    {
      label: '适用门店', name: 'orgId',itemType: 'select', labelKey: 'name', key: 'id', data: 'companyList'
    },
  ],
  footer: [
    {label: '导出', render: 'exportRender'},
    {label: '导入', render: 'importRender'},
  ],
  batchActions: [
    {
      label: '开始日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateStart'],
    },
    {
      label: '结束日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateEnd'],
    },
    {
      label: '删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchDel'],
    }
  ]
}
